import { DividerProps as DividerPropsMui } from '@mui/material';
import { StyledDivider, StyledVerticalDivider } from './Divider.styles';

export interface DividerProps
  extends Pick<DividerPropsMui, 'orientation' | 'flexItem' | 'variant'> {
  readonly noMargin?: boolean;
  readonly light?: boolean;
  readonly fullWidth?: boolean;
}

export interface VerticalDividerProps
  extends Pick<DividerPropsMui, 'flexItem' | 'variant'> {
  readonly noMargin?: boolean;
  readonly light?: boolean;
}

export function Divider({
  light = true,
  fullWidth,
  noMargin,
  orientation,
  ...rest
}: DividerProps) {
  // Return VerticalDivider when orientation is vertical
  if (orientation === 'vertical') {
    return (
      <StyledVerticalDivider
        light={light}
        noMargin={noMargin}
        orientation="vertical"
        {...rest}
      />
    );
  }

  // Return horizontal divider (default)
  return (
    <StyledDivider
      fullWidth={fullWidth}
      light={light}
      noMargin={noMargin}
      {...rest}
    />
  );
}

export function VerticalDivider({
  light = true,
  noMargin,
  ...rest
}: VerticalDividerProps) {
  return (
    <StyledVerticalDivider
      light={light}
      noMargin={noMargin}
      orientation="vertical"
      {...rest}
    />
  );
}
